<template>
<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-color-user`]" width="1em" height="1em" v-bind="$attrs"><path d="M2.3085 17.8152C2.3085 17.3629 2.3085 17.1367 2.32678 16.9462C2.50973 15.039 4.01936 13.5294 5.92654 13.3464C6.11708 13.3281 6.34325 13.3281 6.79557 13.3281H17.2049C17.6572 13.3281 17.8834 13.3281 18.0739 13.3464C19.9811 13.5294 21.4908 15.039 21.6737 16.9462C21.692 17.1367 21.692 17.3629 21.692 17.8152C21.692 18.0414 21.692 18.1544 21.6828 18.2497C21.5914 19.2033 20.8366 19.9581 19.883 20.0496C19.7877 20.0587 19.6746 20.0587 19.4485 20.0587H4.55204C4.32587 20.0587 4.21279 20.0587 4.11752 20.0496C3.16393 19.9581 2.40912 19.2033 2.31764 18.2497C2.3085 18.1544 2.3085 18.0414 2.3085 17.8152Z" stroke="#165DFF" stroke-width="1.66" stroke-linejoin="round"/><rect x="8.39" y="3.203" width="7.22" height="7.22" rx="3.61" stroke="#00BBD8" stroke-width="1.66" stroke-linejoin="round"/></svg>
</template>
<script>

export default {
  name: 'IconColorUser',
  props: {
    prefix: {
        type: String,
        default: 'sc',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
